<template>
    <div>        
        <list :label="$t('sessions')" v-bind:refresh="this.refresh" table='sessions' v-on:childMessage="onMessageFromListReceived" initialSortBy="isactive" :initialSortDesc="true" :hideNewAndEdit="true"></list>                
    </div>
</template>

<script>

import List from "@/components/List"
import Api from "@/Api"
import { Utils } from "@/Utils"

export default {
    components:
    {
        List
    },

    data()
    {
        return {
            showDialog: "",
            fields: [],
            refresh: 0,
            title: "",
            text: ""
        };
    },    

    mixins: [Utils],

    methods:
    {
        onMessageFromListReceived (message)
        {
            this.text = "";
            if (message.cmd === "newRecord")
            {
                this.title = this.$t("new setting");
                this.fields = JSON.parse(JSON.stringify(message.header));
                this.fields.shift(); //remove ID

                for (let field of this.fields)
                {                    
                    field.model = "";
                }
                this.showDialog = true;
            }
            else if (message.cmd === "updRecord")
            {
                this.title = this.$t("new setting");
                this.fields = JSON.parse(JSON.stringify(message.header));
                for (let field of this.fields)
                {                    
                    field.model = message.item[field.value]
                }

                this.showDialog = true;
            }
            else if (message.cmd === "delRecord")
            {
                const id = message.item["id"];
                const self = this;
                Api.deleteRecord("settings", id).then(function(result)
                {
                    if (result.status === 200)
                    {
                        self.refresh += 1;
                    }
                    else
                        alert (self.$t("action not possible"));

                })
                .catch((e) =>
                {
                    alert (self.$t("action not possible"));
                });
            }
        },
        cancel ()
        {
            this.showDialog = "";
            this.fields = [];
        },
        save ()
        {
            const self = this;
            this.text = "";
            for (let field of this.fields)
            {                
                if (field.text === "Name")
                    if (field.model.trim() == "")
                    {
                        this.text = this.$t("enter name");
                        return;
                    }
                    else
                        break;
            }
            Api.saveRecord("settings", this.fields).then(function(result)
            {
                if (result.status === 200)
                {
                    self.showDialog = "";
                    self.refresh += 1;
                }
                else
                    self.text = self.$t("action not possible");

            })
            .catch((e) =>
            {
                self.text = self.$t("action not possible");
            });
        }
    }
};
</script>